import React from "react";
import "./QuizAttemptsCard.css";

const defaultAttemptData = [
  {
    id: "01",
    status: "Completed",
    started: "08/07/2026 01:01:27 PM",
    completed: "09/07/2026 06:38:31 PM",
    rank: "0/0",
    marks: "4/480",
    questions: "1/120",
    progress: 1,
    color: "green",
  },
  {
    id: "02",
    status: "Completed",
    started: "05/07/2026 09:15:12 AM",
    completed: "05/07/2026 02:45:16 PM",
    rank: "0/0",
    marks: "6/480",
    questions: "2/120",
    progress: 1,
    color: "cyan",
  },
  {
    id: "03",
    status: "Completed",
    started: "02/07/2026 07:20:10 PM",
    completed: "02/07/2026 11:05:24 PM",
    rank: "0/0",
    marks: "8/480",
    questions: "3/120",
    progress: 1,
    color: "blue",
  },
  {
    id: "04",
    status: "Completed",
    started: "28/06/2026 05:04:33 PM",
    completed: "28/06/2026 09:10:14 PM",
    rank: "0/0",
    marks: "7/480",
    questions: "2/120",
    progress: 1,
    color: "purple",
  },
];

const QuizAttemptsCard = ({
  attempts = defaultAttemptData,
  isLoading = false,
  onReviewAttempt,
}) => (
  <section className="attempteds-section">
    <div className="attempteds-heading mt-3">
      <h3>Attempts</h3>
    </div>

    <div className="attempteds-grid">
      {isLoading
        ? Array.from({ length: 2 }).map((_, index) => (
            <div className="attempted-card" key={`attempt-skeleton-${index}`}>
              <div className="dashboard-skeleton dashboard-skeleton--thumb" style={{ width: 56, height: 56, borderRadius: 13 }} />
              <div className="dashboard-skeleton dashboard-skeleton--line dashboard-skeleton--title mt-3" />
              <div className="dashboard-skeleton dashboard-skeleton--line mt-2" />
              <div className="dashboard-skeleton dashboard-skeleton--line mt-2" />
            </div>
          ))
        : null}

      {!isLoading && !attempts.length ? (
        <p className="choose-state__status">No attempts available.</p>
      ) : null}

      {!isLoading
        ? attempts.map((attempt) => {
            const progress = Math.min(Math.max(attempt.progress || 0, 0), 100);

            return (
              <div className="attempted-card" key={attempt.id}>
                <div className="attempted-top">
                  <div className={`attempted-number ${attempt.color}`}>
                    {attempt.id}
                    <span className="attempted-check">
                      <i className="bi bi-check" />
                    </span>
                  </div>

                  <div className="attempted-details">
                    <h4>{attempt.status}</h4>
                    <p>
                      <span>Started:</span> <strong>{attempt.started}</strong>
                    </p>
                    <p>
                      <span>Completed:</span> <strong>{attempt.completed}</strong>
                    </p>
                  </div>
                </div>

                <div className="attempted-progress">
                  <div className="attempted-progress-bar">
                    <span
                      className="attempted-progress-fill"
                      style={{ width: `${progress}%` }}
                    />
                  </div>
                  <span className="attempted-progress-percent">{progress}%</span>
                </div>

                <div className="attempted-bottom">
                  <div className="attempted-stat">
                    <div className="attempted-stat-icon">
                      <i className="bi bi-trophy" />
                    </div>
                    <div className="attempted-stat-content">
                      <strong>{attempt.rank}</strong>
                      <div className="attempt-text">Rank</div>
                    </div>
                  </div>

                  <div className="attempted-stat">
                    <div className="attempted-stat-icon">
                      <i className="bi bi-file-earmark-text" />
                    </div>
                    <div className="attempted-stat-content">
                      <strong>{attempt.marks}</strong>
                      <div className="attempt-text">Marks</div>
                    </div>
                  </div>

                  <div className="attempted-stat">
                    <div className="attempted-stat-icon">
                      <i className="bi bi-chat-square-text" />
                    </div>
                    <div className="attempted-stat-content">
                      <strong>{attempt.questions}</strong>
                      <div className="attempt-text">Questions</div>
                    </div>
                  </div>

                  {attempt.canReview !== false ? (
                    <button
                      type="button"
                      className="attempted-review-btn"
                      onClick={() => onReviewAttempt?.(attempt)}
                      disabled={!attempt.assesmentBatchId}
                    >
                      Review
                    </button>
                  ) : null}
                </div>
              </div>
            );
          })
        : null}
    </div>
  </section>
);

export default QuizAttemptsCard;
